// extracted by mini-css-extract-plugin
module.exports = {"close_button":"_1fALb","closeButton":"_1fALb","modal-content":"_3PYiw","modalContent":"_3PYiw"};